
import Vue from 'vue';
import lottie, { AnimationItem } from 'lottie-web';

interface Data {
  style: Record<string, string>;
  anim: AnimationItem;
}

export default Vue.extend({
  props: {
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    startAnimation: {
      type: Boolean,
      default: false,
    },
    reverseAnimation: {
      type: Boolean,
      default: false,
    },
    stopAnimation: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      style: {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%',
      },
      anim: {} as AnimationItem,
    };
  },
  watch: {
    startAnimation(value: boolean) {
      if (value) {
        this.anim.setDirection(1);
        this.anim.play();
      }
    },
    reverseAnimation(value: boolean) {
      if (value) {
        this.anim.setDirection(-1);
        this.anim.play();
      }
    },
    stopAnimation(value: boolean) {
      if (value) {
        this.anim.stop();
      }
    },
  },
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer as Element,
      renderer: 'svg',
      loop: this.options.loop !== false,
      autoplay: this.options.autoplay !== false,
      animationData: this.options.animationData.default,
      rendererSettings: this.options.rendererSettings,
    });
    const speed = this.options.speed ?? 1;

    this.anim.setSpeed(speed);
    this.anim.addEventListener('complete', () => {
      this.$emit('completed');
    });
  },
});
